/**
 * src/web/components/chat-room-members-panel.jsx
 */

import React from 'react'
import connect from '../../connects/chat-room-members-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  IconMenu,
  MenuItem,
  MenuDivider,
} from 'react-toolbox/lib/menu'
import ConfirmDialog from './confirm-dialog.jsx'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import lightButtonTheme from './themes/light-button.css'
import _ from 'lodash'

class ChatRoomMemberList extends React.Component {
  state = {}

  render() {
    const {
      t,
      chatRoom,
      user,
      leaveChatRoom,
    } = this.props
    const otherMembers = chatRoom && _.filter(chatRoom.members, (member)=> member.user_id != user.user_id)

    if (!chatRoom.members || chatRoom.members.length == 0)
      return null

    return (
      <div>
        <List>
          {_.map(otherMembers, (member, i)=> 
            <ListItem key={member.user_id} index={i}
                avatar={member.icon_image.thumb_url}
                caption={member.name}
                rightActions={_.filter([
                  <IconButton key='button' icon='close'
                      disabled={otherMembers.length < 2 || member.user_id == user.user_id}
                      onClick={()=> this.setState({ [member.user_id]: true })} />,
                  <ConfirmDialog key={'confirm'+member.user_id}
                      title={t('label:メンバーを削除', { name: member.name })}
                      open={this.state[member.user_id]}
                      onYes={()=> {
                        this.setState({ [member.user_id]: false })
                        leaveChatRoom(member, this.props)
                      }}
                      onNo={()=> { this.setState({ [member.user_id]: false }) }}
                      yesLabel={t('label:削除')}
                      noLabel={t('label:取り消し')} />
                  ])} />
              )}
        </List>
      </div>
    )
  }
}

class ChatRoomMembersPanel extends React.Component {
  state = {}

  render() {
    const {
      t,
      chatRoom,
      user,
      showUserSelectionDialog,
      leaveChatRoom,
      joinChatRoom,
      fetchChatRooms,
      closeRightSidePage,
    } = this.props

    return (
      <Card theme={theme}>
        <CardActions>
          <Button raised theme={successButtonTheme}
            icon='person_add'
            label={t('label:メンバーを追加')}
            style={{ verticalAlign: 'bottom', mergin: '2px 5px' }}
            onClick={()=> {
              showUserSelectionDialog(
                t('label:ユーザを選択'), true, 'ACCOUNT_MEMBERS',
                undefined, undefined, (users)=> _.each(users, (user)=> joinChatRoom(user.user_id))
                )}}
          />
          {chatRoom.members && chatRoom.members.length > 2  &&
          <Button raised theme={lightButtonTheme}
            icon='person_outline'
            label={t('label:退室')}
            onClick={()=> {
              this.setState({ [user.user_id]: true }) }}
          />}
          {chatRoom.members && chatRoom.members.length > 2  &&
          <ConfirmDialog key={'leave'}
            open={this.state[user.user_id]}
            title={t('label:退室してもいいですか')}
            onYes={()=> {
              this.setState({ [user.user_id]: false })
              leaveChatRoom(user, this.props)
            }}
            onNo={()=> this.setState({ [user.user_id]: false })}
            yesLabel={t('label:退室')}
            noLabel={t('label:取り消し')} />}

        </CardActions>

        <CardText>
          {(!chatRoom.members || chatRoom.members.length == 0) &&
            <List >
              <ListItem caption={t('label:メンバーは登録されていません')} />
            </List>
          }
          <ChatRoomMemberList {...this.props} />
        </CardText>
      </Card>
    )
  }
}

export default connect(ChatRoomMembersPanel)



// WEBPACK FOOTER //
// ./src/web/components/chat-room-members-panel.jsx